import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ShopByRoastModal from "./ShopByRoastModal.jsx";
import ShopByRoastPDP from "./ShopByRoastPDP.jsx";

const modalRoot = document.getElementById("shop-by-roast-modal-root");
const modalRootMobile = document.getElementById("shop-by-roast-modal-mobile-root");
const pdpRoot = document.getElementById("shop-by-roast-pdp-root");

if (modalRoot) {
  const root = ReactDOM.createRoot(modalRoot);
  root.render(
    <React.StrictMode>
      <ShopByRoastModal />
    </React.StrictMode>
  );
} else {
  console.warn("shop-by-roast-modal-root element not found.");
}

if (modalRootMobile) {
  const root = ReactDOM.createRoot(modalRootMobile);
  root.render(
    <React.StrictMode>
      <ShopByRoastModal />
    </React.StrictMode>
  );
}

if (pdpRoot) {
  const root2 = ReactDOM.createRoot(pdpRoot);
  root2.render(
    <React.StrictMode>
      <ShopByRoastPDP />
    </React.StrictMode>
  );
} else {
  console.warn("shop-by-roast-pdp-root element not found.");
}
